"use client"

import { Navigate } from "react-router-dom"
import { useAuth } from "../../../contexts/AuthContext"

function Recharge() {
  const { user } = useAuth()

  if (!user) {
    return <Navigate to="/signin" replace />
  }

  if (["superadmin", "admin"].includes(user.role)) {
    return <Navigate to="/admin-recharge" replace />
  }

  return <Navigate to="/user-recharge" replace />
}

export default Recharge
